import React, { useState, useRef, useEffect } from 'react';

/* 1. OurServicesCardForServicePage fade effects */
export function FadeInFromBottomSection({ children, className = "" }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.05 });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={ref} 
      className={`fade-in-bottom-section ${visible ? "visible" : ""} ${className}`}
    >
      {children}
    </section>
  );
}
/* -----ends here------ */

/* 2. ServicesHero fade effects */
export function FadeInFromLeft({ children, delayClass }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.1 });
    if(ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`fade-in-left ${visible ? 'visible' : ''} ${delayClass}`}
    >
      {children}
    </div>
  );
}

export function FadeInFromRightImg({ src, alt, className = '', style = {} }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.1 });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={`fade-in-right-img ${visible ? 'visible' : ''} ${className}`}
      style={style}
      draggable={false}
    />
  );
}
/* -----ends here------ */